import { useMutation } from '@apollo/client';
import { Button, Modal } from 'antd';
import { ROUTES } from '../../../common/constants';
import useRouter from '../../../hooks/useRouter';
import { ModalType } from '../../../types/common.type';
import '../../profile/profile.less';
import { DELETE_ACCOUNT } from '../graphql/muatations';

type ReusableActionModalProps = {
  type: 'delete' | 'signout';
} & ModalType;

const ReusableActionModal = ({
  visible,
  onClose,
  title,
  content,
  type,
}: ReusableActionModalProps) => {
  const { navigate } = useRouter();

  const [deleteAccount] = useMutation(DELETE_ACCOUNT, {
    onCompleted: () => {
      localStorage.clear();
      navigate(ROUTES.LOGIN);
    },
    onError() {},
  });

  const handleAction = () => {
    if (type === 'delete') {
      deleteAccount();
    } else if (type === 'signout') {
      navigate(ROUTES.SIGNOUT);
    }
  };

  const getActionLabel = () => {
    return type === 'delete' ? 'Delete' : 'Sign Out';
  };

  return (
    <Modal
      className="custom-modal body-meta medium"
      centered
      open={visible}
      title={<div className="body-lg medium">{title}</div>}
      closeIcon={false}
      footer={[
        <Button
          key="cancel"
          onClick={onClose}
          type="text"
          className="cancel-btn"
        >
          Cancel
        </Button>,
        <Button
          key="action"
          onClick={handleAction}
          type="text"
          className="custom-btn"
        >
          {getActionLabel()}
        </Button>,
      ]}
    >
      {content}
    </Modal>
  );
};

export default ReusableActionModal;
